<template>
  <div>
    <el-card class="box-card">
      <el-button type="info" @click="backCustomerManagement">返回</el-button>

      <el-table :data="dataList" border stripe class="mt15">
        <el-table-column prop="Diopter" label="屈光度"></el-table-column>
        <el-table-column prop="AdminuserName" label="管理员"></el-table-column>
        <el-table-column prop="Createtime" label="时间"></el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pages">
        <el-pagination
          @current-change="handleCurrentPageChange"
          :page-size="10"
          layout="total, prev, pager, next, jumper"
          :total="dataListnum"
          :current-page.sync="selectedPageNo">
        </el-pagination>
      </div>

    </el-card>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      parentdata: null
    }
  },
  mounted () {
  },
  methods: {
    LoadData (parentdata) {
      this.parentdata = parentdata
      this.apiGetRslevCpuidSetdiopterNum()
      this.apiGetRslevCpuidSetdiopterList()
    },
    backCustomerManagement () {
      this.$emit('triggerFunc', '')
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetRslevCpuidSetdiopterList()
    },
    apiGetRslevCpuidSetdiopterList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        cpuid: that.parentdata.Cpuid,
        pageno: that.selectedPageNo
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetRslevCpuidSetdiopterList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetRslevCpuidSetdiopterNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        cpuid: that.parentdata.Cpuid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetRslevCpuidSetdiopterNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
